import React, { useState } from 'react';

export const useImageMask = ({ magnificationFactor }: { magnificationFactor: number }) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const [previewCoords, setPreviewCoords] = useState<{
    left?: number;
    right?: number;
  }>({});

  const handleMaskMouseEnter = (event: React.MouseEvent) => {
    setIsPreviewOpen(true);

    const screenWidth = window.innerWidth;
    const maskWidth = 9 * magnificationFactor;
    let left;
    if (event.clientX < screenWidth / 2) {
      left = event.clientX + 150;
    } else {
      left = event.clientX - maskWidth - 150;
    }
    setPreviewCoords({ left });
  };
  const handleMaskMouseLeave = () => setIsPreviewOpen(false);

  return {
    isPreviewOpen,
    previewCoords,
    setIsPreviewOpen,
    setPreviewCoords,
    handleMaskMouseEnter,
    handleMaskMouseLeave,
  };
};
